import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Card from '../components/ui/Card'
import Icon from '../components/ui/Icon'

const UserGuide = () => {
  const steps = [
    {
      step: '১',
      title: 'রেজিস্ট্রেশন করুন',
      description: 'আপনার নাম, ফোন নাম্বার, দেশ এবং পাসওয়ার্ড দিয়ে অ্যাকাউন্ট তৈরি করুন।',
      tips: [
        'সঠিক ফোন নাম্বার দিন কারণ এখানে OTP পাঠানো হবে',
        'সহজ কিন্তু নিরাপদ পাসওয়ার্ড রাখুন',
        'দেশের নাম সঠিকভাবে নির্বাচন করুন'
      ],
      icon: 'UserPlus'
    },
    {
      step: '২',
      title: 'ফোন নাম্বার ভেরিফাই করুন',
      description: 'রেজিস্ট্রেশনের পর আপনার ফোন নাম্বারে OTP পাঠানো হবে। এটি প্রবেশ করিয়ে ভেরিফাই করুন।',
      tips: [
        'OTP সাধারণত ১-২ মিনিটের মধ্যে আসে',
        'দিনে একবারই OTP পাঠানো হয়',
        'OTP সঠিক হওয়া নিশ্চিত করুন',
        'সকল ৬ সংখ্যা পূরণ করার পর ভেরিফাই বাটনে ক্লিক করুন'
      ],
      icon: 'Shield'
    },
    {
      step: '৩',
      title: 'প্রোফাইল সেটআপ করুন',
      description: 'আপনার প্রোফাইলে গিয়ে সেটিংস কনফিগার করুন এবং আপনার পছন্দ অনুযায়ী সাজান।',
      tips: [
        'অন্যরা আপনাকে জাগাবে কিনা সেটিং চালু করুন',
        'আপনার কল টাইম পছন্দ সেট করুন',
        'ব্যক্তিগত ফজর টাইম নির্ধারণ করুন (ঐচ্ছিক)'
      ],
      icon: 'Settings'
    },
    {
      step: '৪',
      title: 'ফজর জাগরণ রিপোর্ট করুন',
      description: 'প্রতিদিন ফজর নামাজের পর প্রোফাইলে গিয়ে রিপোর্ট করুন যে আপনি উঠেছেন।',
      tips: [
        'নিজে উঠলে "আমি নিজে উঠেছি" টগল চালু করুন',
        'অন্য কেউ জাগালে স্বয়ংক্রিয়ভাবে রিপোর্ট হবে',
        'পয়েন্ট অর্জন করুন (নিজে উঠলে ৫ পয়েন্ট)'
      ],
      icon: 'Sun'
    },
    {
      step: '৫',
      title: 'অন্যদের জাগিয়ে দিন',
      description: '"জাগিয়ে দিন" পেজে গিয়ে অন্য মুসলিম ভাইদের ফজরের জন্য জাগিয়ে দিন।',
      tips: [
        'র‍্যান্ডম নাম্বার পাবেন যারা এখনো জাগেনি',
        'সালাম দিয়ে ভদ্রভাবে জাগিয়ে দিন',
        'কল স্ট্যাটাস আপডেট করতে ভুলবেন না',
        'অন্যকে জাগালে ১০ পয়েন্ট, কল দিলে ২ পয়েন্ট পাবেন'
      ],
      icon: 'Phone'
    },
    {
      step: '৬',
      title: 'কমিউনিটি তৈরি করুন',
      description: 'পরিবার বা বন্ধুদের সাথে কমিউনিটি তৈরি করে একসাথে ফজর জাগরণ করুন।',
      tips: [
        'কমিউনিটি নাম দিয়ে তৈরি করুন',
        'অন্যদের ইনভাইট করুন',
        'কমিউনিটি মেম্বারদের অগ্রাধিকার দিন',
        'একসাথে প্রতিযোগিতা করুন'
      ],
      icon: 'Users'
    }
  ]

  const tips = [
    {
      title: 'সময় ব্যবস্থাপনা',
      icon: 'Clock',
      content: [
        'ফজরের ১৫-২০ মিনিট আগে ঘুম থেকে উঠুন',
        'রাতে তাড়াতাড়ি ঘুমিয়ে যান',
        'নিয়মিত সময়সূচী মেনে চলুন'
      ]
    },
    {
      title: 'কল শিষ্টাচার',
      icon: 'Heart',
      content: [
        'সালাম দিয়ে কল শুরু করুন',
        'ভদ্র ও সম্মানজনক ভাষা ব্যবহার করুন',
        'প্রয়োজনে ২-৩ বার কল করুন',
        'কল স্ট্যাটাস সঠিকভাবে আপডেট করুন'
      ]
    },
    {
      title: 'পয়েন্ট সিস্টেম',
      icon: 'Award',
      content: [
        'নিজে উঠলে: ৫ পয়েন্ট',
        'অন্যকে উঠালে: ১০ পয়েন্ট',
        'কল দিলে: ২ পয়েন্ট',
        'মাসিক র‍্যাংকিং এ অংশ নিন'
      ]
    },
    {
      title: 'গোপনীয়তা ও নিরাপত্তা',
      icon: 'Lock',
      content: [
        'আপনার নাম্বার শুধু নির্বাচিত ব্যক্তিই দেখবে',
        'দিনে সর্বোচ্চ ৫টি নাম্বার দেখানো হবে',
        'ব্যক্তিগত তথ্য সুরক্ষিত রাখা হয়',
        'যেকোনো সময় সেবা বন্ধ করতে পারেন'
      ]
    }
  ]

  const faqs = [
    {
      q: 'যদি কেউ আমাকে কল না দেয়?',
      a: 'চিন্তার কিছু নেই। সিস্টেম এমনভাবে ডিজাইন করা যে সবাইকে কল দেওয়ার চেষ্টা করা হয়। তবে ১০০% গ্যারান্টি দেওয়া সম্ভব নয়।'
    },
    {
      q: 'আমি কি কল রিসিভ না করলে সমস্যা হবে?',
      a: 'না, কোনো সমস্যা নেই। আপনি কল রিসিভ না করলে বা ব্যস্ত থাকলে কোনো জরিমানা নেই। শুধু স্ট্যাটাস আপডেট করবেন।'
    },
    {
      q: 'পয়েন্ট দিয়ে কী করা যাবে?',
      a: 'পয়েন্ট আপনার অগ্রগতি ট্র্যাক করতে সাহায্য করে। মাসিক র‍্যাংকিং এ অংশগ্রহণ করুন এবং পুরস্কার জিতুন।'
    },
    {
      q: 'আমি কি যেকোনো দিন স্কিপ করতে পারি?',
      a: 'হ্যাঁ, আপনি প্রোফাইল সেটিংস থেকে যেকোনো দিন নিজেকে অনুপলব্ধ রাখতে পারেন।'
    }
  ]

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="BookOpen" className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">কিভাবে ব্যবহার করবেন</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            ফজরফাইটার ব্যবহার করে কিভাবে নিয়মিত ফজরে উঠবেন এবং অন্যদের সাহায্য করবেন - সহজ গাইড
          </p>
        </div>

        {/* Step by Step Guide */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12">ধাপে ধাপে গাইড</h2>
          <div className="space-y-8">
            {steps.map((step, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
                <div className="flex flex-col md:flex-row items-start gap-6">
                  {/* Step Number and Icon */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mb-4">
                      <span className="text-white font-bold text-xl">{step.step}</span>
                    </div>
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto">
                      <Icon name={step.icon} className="w-6 h-6 text-gray-600" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-foreground mb-3">{step.title}</h3>
                    <p className="text-muted-foreground mb-4 text-lg leading-relaxed">
                      {step.description}
                    </p>
                    <div className="bg-green-50 rounded-lg p-4">
                      <h4 className="font-semibold text-green-800 mb-2 flex items-center">
                        <Icon name="Lightbulb" className="w-4 h-4 mr-2" />
                        টিপস:
                      </h4>
                      <ul className="space-y-1">
                        {step.tips.map((tip, tipIndex) => (
                          <li key={tipIndex} className="text-sm text-green-700 flex items-start">
                            <span className="text-green-500 mr-2 mt-1">•</span>
                            {tip}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Tips Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12">গুরুত্বপূর্ণ টিপস</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {tips.map((tip, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <Icon name={tip.icon} className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground">{tip.title}</h3>
                </div>
                <ul className="space-y-2">
                  {tip.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-muted-foreground flex items-start">
                      <span className="text-blue-500 mr-2 mt-1">✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12">প্রায়শই জিজ্ঞাসিত প্রশ্ন</h2>
          <div className="max-w-4xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <Card key={index} className="p-6">
                <h3 className="text-lg font-bold text-foreground mb-3 flex items-center">
                  <Icon name="HelpCircle" className="w-5 h-5 mr-2 text-blue-500" />
                  {faq.q}
                </h3>
                <p className="text-muted-foreground leading-relaxed pl-7">
                  {faq.a}
                </p>
              </Card>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <Card className="p-8 bg-gradient-to-r from-green-50 to-blue-50 border-green-200">
            <Icon name="Heart" className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-foreground mb-4">
              এখনই শুরু করুন!
            </h2>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              আল্লাহর সন্তুষ্টির জন্য নিয়মিত ফজরে উঠুন এবং অন্য মুসলিম ভাই-বোনদের সাহায্য করুন।
              একসাথে আমরা একটি জাগ্রত উম্মাহ গড়ব ইনশাআল্লাহ।
            </p>
            <div className="space-x-4">
              <a
                href="/register"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-blue-600 text-white rounded-lg font-medium hover:from-green-700 hover:to-blue-700 transition-colors"
              >
                <Icon name="UserPlus" className="w-5 h-5 mr-2" />
                রেজিস্ট্রেশন করুন
              </a>
              <a
                href="/login"
                className="inline-flex items-center px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
              >
                <Icon name="LogIn" className="w-5 h-5 mr-2" />
                লগিন করুন
              </a>
            </div>
          </Card>
        </div>

        {/* Contact Section */}
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">আরও সাহায্য প্রয়োজন?</h2>
          <Card className="p-6 max-w-2xl mx-auto">
            <div className="space-y-4">
              <p className="text-muted-foreground">
                সাহায্য, ডোনেশন, স্পন্সর, সাজেশন, বাগ রিপোর্টসহ যেকোনো প্রয়োজনে যোগাযোগ করুন:
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6">
                <a
                  href="https://wa.me/8801314951751"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-green-600 hover:text-green-700"
                >
                  <Icon name="MessageCircle" className="w-5 h-5 mr-2" />
                  +880 1314-951751 (WhatsApp)
                </a>
                <a
                  href="https://wa.me/8801703788889"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-green-600 hover:text-green-700"
                >
                  <Icon name="MessageCircle" className="w-5 h-5 mr-2" />
                  +880 1703-788889 (WhatsApp)
                </a>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default UserGuide